import script from "./TableViewPublishModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableViewPublishModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__